import { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
} from "reactstrap";
import PageContainer from "../Layout/PageContainer";
import subscriptionService from "../../redux/services/subscription.service";
import { useDispatch, useSelector } from "react-redux";
import { getFeatures } from "../../redux/actions/subscription";
import { toast, Slide } from "react-toastify";
import { useNavigate } from "react-router-dom";

toast.configure();
const SubscriptionAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { features } = useSelector((state) => state?.subscriptionReducer);

  const [formData, setFormData] = useState({
    planFor: "0",
    title: "",
    description: "",
    isPopular: false,
    frequency: "0",
    price: "0",
    type: 0,
    featureIds: [],
    accesses: {},
  });
  const [userType, setUserType] = useState({ planFor: "0" });
  const [filteredFeatures, setFilteredFeatures] = useState([]);
  const [benefitOptions, setBenefitOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(getFeatures(1));
  }, [dispatch]);

  // useEffect(() => {
  //   if (features && userType.planFor !== "") {
  //     const filtered = features.filter(
  //       (feature) => feature.featureFor === userType.planFor
  //     );
  //     setFilteredFeatures(filtered);
  //   } else {
  //     setFilteredFeatures([]);
  //   }
  // }, [userType.planFor, features]);

  useEffect(() => {
    if (features && userType.planFor !== "") {
      const filtered = features.filter(
        (feature) => feature.featureFor === userType.planFor,
      );
      setFilteredFeatures(filtered);

      //  Auto-select the first feature only
      const firstFeature = filtered[0];
      if (firstFeature) {
        const defaultFeatureId = firstFeature.publicId;
        const defaultOptions = {
          [defaultFeatureId]: { type: "one", number: 1 },
        };

        setFormData((prev) => ({
          ...prev,
          featureIds: [defaultFeatureId],
          accesses: getAccesses(defaultOptions),
        }));

        setBenefitOptions(defaultOptions);
      } else {
        // If no features found
        setFormData((prev) => ({
          ...prev,
          featureIds: [],
          accesses: {},
        }));
        setBenefitOptions({});
      }
    } else {
      setFilteredFeatures([]);
      setFormData((prev) => ({
        ...prev,
        featureIds: [],
        accesses: {},
      }));
      setBenefitOptions({});
    }
  }, [userType.planFor, features]);

  const handleCheckboxChange = (publicId) => {
    let updatedBenefits = [...formData.featureIds];
    let updatedOptions = { ...benefitOptions };

    if (updatedBenefits.includes(publicId)) {
      updatedBenefits = updatedBenefits.filter((id) => id !== publicId);
      delete updatedOptions[publicId];
    } else {
      updatedBenefits.push(publicId);
      updatedOptions[publicId] = { type: "one", number: 1 };
    }

    setFormData((prev) => ({
      ...prev,
      featureIds: updatedBenefits,
      accesses: getAccesses(updatedOptions),
    }));
    setBenefitOptions(updatedOptions);
  };

  const handleOptionChange = (publicId, option) => {
    let updatedOptions = { ...benefitOptions };
    if (option === "one") {
      updatedOptions[publicId] = { type: "one", number: 1 };
    } else if (option === "infinity") {
      updatedOptions[publicId] = { type: "infinity", number: 1 };
    } else if (option === "number") {
      updatedOptions[publicId] = {
        ...updatedOptions[publicId],
        type: "number",
        number: updatedOptions[publicId]?.number || 1,
      };
    }
    setFormData((prev) => ({
      ...prev,
      accesses: getAccesses(updatedOptions),
    }));
    setBenefitOptions(updatedOptions);
  };

  const handleNumberChange = (publicId, value) => {
    let num = parseInt(value);
    if (isNaN(num) || num < 1) num = 1;
    let updatedOptions = { ...benefitOptions };
    updatedOptions[publicId].number = num;
    setFormData((prev) => ({
      ...prev,
      accesses: getAccesses(updatedOptions),
    }));
    setBenefitOptions(updatedOptions);
  };

  const getAccesses = (options) => {
    let acc = {};
    Object.keys(options).forEach((key) => {
      if (options[key].type === "infinity") {
        acc[key] = "Infinity";
      } else if (options[key].type === "one") {
        acc[key] = 1;
      } else if (options[key].type === "number") {
        acc[key] = options[key].number;
      }
    });
    return acc;
  };

  const handleFrom = (e) => {
    formData.planFor = e.target.value;
    setUserType({ ...userType, planFor: e.target.value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      planFor: "",
    }));
  };

  const handleChange = (e) => {
    const { name, value, type: inputType, checked } = e.target;
    let val = inputType === "checkbox" ? (checked ? 1 : 0) : value;

    if (name === "type") {
      val = parseInt(value);
      setFormData((prev) => ({
        ...prev,
        type: val,
        price: val === 0 ? "0" : prev.price, // Set price to 0 for free
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: val,
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.planFor) newErrors.planFor = "Plan Type is required";
    if (!formData.frequency) newErrors.frequency = "Billing Cycle is required";
    const type = Number(formData.type);
    const price = Number(formData.price);

    if (type !== 0 && (isNaN(price) || price <= 0)) {
      newErrors.price = "Price must be greater than 0";
    }
    if (!formData.title || !formData.title.trim())
      newErrors.title = "Plan Title is required";
    if (formData.isPopular === "")
      newErrors.isPopular = "Popular Plan is required";
    if (!formData.description || !formData.description.trim())
      newErrors.description = "Description is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      subscriptionService
        .createSubscription(formData)
        .then(
          (res) => {
            setLoading(false);
            if (res.status === 200) {
              toast(res.data.message, {
                transition: Slide,
                closeButton: true,
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              navigate("/subscription/list");
            } else {
              toast(res.data.message, {
                transition: Slide,
                closeButton: true,
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          },
          (err) => {
            toast(err.response.data.message, {
              transition: Slide,
              closeButton: true,
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
            setLoading(false);
          },
        )
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  const subscriptionTypes = [
    { id: "free", label: "Free", value: 0 },
    { id: "basic", label: "Basic", value: 1 },
    { id: "premium", label: "Premium", value: 2 },
  ];

  return (
    <PageContainer
      pageTitleIcon="pe-7s-shuffle icon-gradient bg-plum-plate"
      pageHeading="Create Subscription"
      pageSubTitle="Create Subscription for Talent & Company"
    >
      <Row>
        <Col md="12">
          <Card className="main-card mb-3">
            <Form onSubmit={handleSubmit}>
              <CardBody>
                <Row>
                  {/* Form Fields */}
                  <Col md="4">
                    <FormGroup>
                      <Label for="price">Select Plan Type</Label>
                      <Input
                        type="select"
                        name="planFor"
                        id="planFor"
                        value={userType.planFor}
                        onChange={handleFrom}
                      >
                        <option value="">Select Plan Type</option>
                        <option value="0">Talent Plan</option>
                        <option value="1">Company Plan</option>
                      </Input>
                      {errors.planFor && (
                        <p className="text-danger">{errors.planFor}</p>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="frequency">Select Billing Cycle</Label>
                      <Input
                        type="select"
                        name="frequency"
                        id="frequency"
                        value={formData.frequency}
                        onChange={handleChange}
                        Select
                        Billing
                        Cycle
                      >
                        <option value="0">Weekly Plan</option>
                        <option value="1">Monthly Plan</option>
                        <option value="2">Quarterly Plan</option>
                        <option value="3">Yearly Plan</option>
                      </Input>
                      {errors.frequency && (
                        <p className="text-danger">{errors.frequency}</p>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="price">Price in SAR</Label>
                      <Input
                        type="text"
                        inputMode="decimal"
                        pattern="^\d*\.?\d*$"
                        name="price"
                        id="price"
                        placeholder="Ex: 1000 or 1000.50"
                        value={formData.price}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow digits and optional decimal point
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        min="0"
                        disabled={formData.type === 0}
                      />

                      {errors.price && (
                        <p className="text-danger">{errors.price}</p>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="title">Plan Title</Label>
                      <Input
                        type="text"
                        name="title"
                        id="title"
                        placeholder="Ex: Demo Plan"
                        value={formData.title}
                        onChange={handleChange}
                      />
                      {errors.title && (
                        <p className="text-danger">{errors.title}</p>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="isPopular">Popular Plan</Label>
                      <Input
                        type="select"
                        name="isPopular"
                        id="isPopular"
                        onChange={handleChange}
                      >
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </Input>
                      {errors.isPopular && (
                        <p className="text-danger">{errors.isPopular}</p>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="plantitle">Description</Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Ex: Demo Plan"
                        value={formData.description}
                        onChange={handleChange}
                      />
                      {errors.description && (
                        <p className="text-danger">{errors.description}</p>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Feature Options */}
                  <Row className="align-items-start">
                    <p className="text-primary fs-6">Select plan features</p>
                    <Col md="8">
                      {filteredFeatures.length > 0 ? (
                        filteredFeatures.map((feature, i) => (
                          <FormGroup key={i}>
                            <Label for={`benefits_${i}`}>{feature.title}</Label>
                            <Input
                              type="checkbox"
                              name={`benefits_${i}`}
                              id={`benefits_${i}`}
                              className="mx-2"
                              onChange={() =>
                                handleCheckboxChange(feature.publicId)
                              }
                              checked={formData.featureIds.includes(
                                feature.publicId,
                              )}
                            />
                            {formData.featureIds.includes(feature.publicId) && (
                              <div className="ml-4 mt-2 d-flex flex-column gap-2">
                                {/* Option - One */}
                                <div className="d-flex align-items-center gap-2">
                                  <Input
                                    type="checkbox"
                                    checked={
                                      benefitOptions[feature.publicId]?.type ===
                                      "one"
                                    }
                                    onChange={() =>
                                      handleOptionChange(
                                        feature.publicId,
                                        "one",
                                      )
                                    }
                                  />
                                  <span>One</span>
                                </div>

                                {/* Option - Number */}
                                <div className="d-flex flex-column">
                                  <div className="d-flex align-items-center gap-2">
                                    <Input
                                      type="checkbox"
                                      checked={
                                        benefitOptions[feature.publicId]
                                          ?.type === "number"
                                      }
                                      onChange={() =>
                                        handleOptionChange(
                                          feature.publicId,
                                          "number",
                                        )
                                      }
                                    />
                                    <span>Number</span>
                                  </div>

                                  {/* Default Number Input */}
                                  {benefitOptions[feature.publicId]?.type ===
                                    "number" && (
                                    <div className="d-flex align-items-center mt-1 ml-4">
                                      <Input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={
                                          benefitOptions[feature.publicId]
                                            ?.number
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (/^\d*$/.test(value)) {
                                            handleNumberChange(
                                              feature.publicId,
                                              value,
                                            );
                                          }
                                        }}
                                        style={{ width: "100px" }}
                                        min={1}
                                      />
                                    </div>
                                  )}
                                </div>

                                {/* Option - Infinity */}
                                <div className="d-flex align-items-center gap-2">
                                  <Input
                                    type="checkbox"
                                    checked={
                                      benefitOptions[feature.publicId]?.type ===
                                      "infinity"
                                    }
                                    onChange={() =>
                                      handleOptionChange(
                                        feature.publicId,
                                        "infinity",
                                      )
                                    }
                                  />
                                  <span>Infinity</span>
                                </div>
                              </div>
                            )}
                          </FormGroup>
                        ))
                      ) : (
                        <span>
                          Please Select plan type to see available features
                        </span>
                      )}
                    </Col>

                    {userType.planFor && (
                      <Col md="4">
                        <FormGroup tag="fieldset">
                          <Label className="d-block text-primary">
                            Choose Subscription Type
                          </Label>
                          {subscriptionTypes.map((type) => (
                            <div className="form-check" key={type.id}>
                              <Input
                                className="form-check-input"
                                type="radio"
                                id={type.id}
                                name="type"
                                value={type.value}
                                checked={formData.type === type.value}
                                onChange={handleChange}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={type.id}
                              >
                                {type.label}
                              </Label>
                            </div>
                          ))}
                          {errors.type && (
                            <p className="text-danger">{errors.type}</p>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                </Row>
              </CardBody>
              <CardFooter className="d-block">
                <Button
                  type="button"
                  color="link"
                  onClick={() => navigate("/subscription/list")}
                >
                  Cancel
                </Button>
                <Button color="primary" size="lg" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageContainer>
  );
};

export default SubscriptionAdd;
